import React from 'react';
import styled from 'styled-components';
import { useWindowSize } from '../../../../hooks/useWindowSize';
import { HighScoreItem } from '../../../../../core/entities/games';
import { games, ui } from '../../../../../core';
import HighScoreTable from '../../../../components/other/HighScoreTable';

// Assets
import ToggleSwitch from '../../../../components/primitive/input/ToggleSwitch';

const RecentHighScores: React.FC<Props> = (props) => {
  const { gameType } = props;
  const { windowWidth } = useWindowSize();
  const [sortColumn, setSortColumn] = React.useState<string>('score');
  const [sortByRecent, setSortByRecent] = React.useState<boolean>(true);
  const [recentHighScores, setRecentHighScores] = React.useState<
    HighScoreItem[]
  >([]);

  React.useEffect(() => {
    const fetch = async () => {
      const resentHighScores = await games.fetchRecentHighScores(100, gameType);
      setRecentHighScores(resentHighScores);
    };
    fetch();
  }, []);

  // deprecated for table sort
  const toggleSort = () => {
    setSortByRecent((prevSortByRecent) => !prevSortByRecent);
  };

  return (
    <Container>
      <Title>LEADERBOARD</Title>
      {/* <StyledSwitch
          id="sortRecent"
          toggled={sortByRecent}
          onChange={toggleSort}
          size="sm"
          label={sortByRecent ? "Sorted by Recent Plays" : "Sorted by All Time Plays"}
        /> */}
      <TableContainer>
        <HighScoreTable
          data={recentHighScores.slice(0, 100)}
          sort={sortByRecent}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
        />
      </TableContainer>
    </Container>
  );
};

export default RecentHighScores;

type Props = {
  gameType: string;
};

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
`;

const Title = styled.h1`
  margin: 0 0 50px 0;

  color: ${({ theme }) => theme.colors.layout.p};
  font-size: 2.5rem;
  font-family: ${({ theme }) => theme.headings.fontFamily};
  white-space: nowrap;
  text-transform: uppercase;
  text-align: center;

  transition: font-size ${({ theme }) => theme.transitionTimingFunction} 500ms;

  text-shadow: 0 0 50px
    ${({ theme }) => ui.hexToRgba(theme.colors.layout.p, 0.5)};

  @media (max-width: ${ui.WIDTH_BREAK_POINTS[1]}px) {
    font-size: 3rem;
    white-space: pre-wrap;
  }

  @media (max-width: ${ui.WIDTH_BREAK_POINTS[0]}px) {
    font-size: 2rem;
  }
`;

const TableContainer = styled.div`
  position: relative;
  width: 70%;

  @media (max-width: ${ui.WIDTH_BREAK_POINTS[1]}px) {
    width: 100%;
  }
`;

const OverlapImage = styled.img`
  position: absolute;
  left: -25%;
  bottom: -300px;
  width: 150%;

  pointer-events: none;

  @media (max-width: ${ui.WIDTH_BREAK_POINTS[1]}px) {
    bottom: -30%;
  }
`;

const StyledSwitch = styled(ToggleSwitch)`
  margin-bottom: 20px;
`;
